import React, { useCallback } from "react";
import { toast } from "react-toastify";
import { Button } from "@commonsku/styles";
import { BulkActionConfigBase } from "../index";
import { useHasCapabilities } from "../../../../hooks";
import { downloadTextFile } from "../../../../utils";
import { buildPodBillsCsv } from "./buildPodBillsCsv";

export function prepareLabel<
  T extends Record<string, unknown> = Record<string, unknown>,
>(selected: T[]): React.ReactNode {
  if (selected.length === 0) {
    return "Select one or more bills";
  }
  if (selected.length === 1) {
    return "1 bill selected";
  }
  return `${selected.length} bills selected`;
}

/** won't handle bulk create bills in mvp
export const CreateBillButton = ({ disabled }: { disabled?: boolean }) => (
  <PlaceholderButton disabled={disabled}>Create Bill</PlaceholderButton>
);
export const MarkAsBilledButton = ({ disabled }: { disabled?: boolean }) => (
  <PlaceholderButton disabled={disabled}>Mark As Billed</PlaceholderButton>
);
*/

export function ExportToCsvButton<
  T extends Record<string, unknown> = Record<string, unknown>,
>({
  selected,
  setExecuting,
  disabled,
}: {
  selected: T[];
  setExecuting: (executing: boolean) => void;
  disabled?: boolean;
}) {
  const canExport = useHasCapabilities(["EXPORT-REPORT"]);

  const handleClick = useCallback(async () => {
    setExecuting(true);
    try {
      const csv = buildPodBillsCsv(selected);
      await downloadTextFile(csv, "pod-bills.csv");
    } catch (e) {
      toast.error("Unable to export bills to CSV");
    } finally {
      setExecuting(false);
    }
  }, [selected, setExecuting]);

  if (!canExport) {
    return null;
  }

  return (
    <Button disabled={disabled} onClick={handleClick}>
      Export to CSV
    </Button>
  );
}

export const BulkActions: BulkActionConfigBase = {
  prepareLabel,
  actions: [ExportToCsvButton],
};
